<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/default_header.png');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("project_list") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div>
      <div class="row align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 px-0">
          <div
            class="mx-0 pa-0 text-content pl-12 pl-md-16 learning-target-table-wrap"
          >
            <div>
              <v-simple-table
                class="trainingstable trainingstable-1"
                style="width: 100%"
                hide-default-footer
              >
                <thead>
                  <tr>
                    <th class="align-center table-trainer-wrapper-head">
                      {{ $t("country") }}
                    </th>
                    <th class="align-center table-trainer-wrapper-head">
                      {{ $t("designation") }}
                    </th>
                    <th class="align-center table-trainer-wrapper-head">
                      {{ $t("salesSource") }}
                    </th>
                    <th class="align-center table-trainer-wrapper-head">
                      {{ $t("project_number") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="designation-border"
                    v-for="project in projects"
                    :key="project.id"
                    @click="
                      $routerPush(
                        '/edit-project?projectId=' + project.id,
                        'UPDATE_SALESLIST_PROJECT'
                      )
                    "
                  >
                    <td class="pb-1 align-center">
                      {{ $t(project.country) }}
                    </td>

                    <td class="pb-1 align-center">
                      {{ project.designations }}
                    </td>

                    <td class="pb-1 align-center">
                      {{ project.salesSource }}
                    </td>

                    <td class="pb-1 align-center">
                      {{ project.projectNumber }}
                    </td>
                  </tr>
                  <tr v-show="projects.length == 0">
                    <td class="pb-1 text-uppercase align-center" colspan="6">
                      {{ $t("no_projects") }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 pl-12 pl-md-16 row">
          <div
            class="col-xl-12 right-side-block"
            v-show="$rights.includes('CREATE_SALESLIST_PROJECT')"
          >
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              :to="`/create-project`"
              v-show="$rights.includes('CREATE_SALESLIST_PROJECT')"
              outlined
              depressed
              tile
              class="savebutton mr-2 mb-2"
              >{{ $t("create_project") }}</v-btn
            >

            <v-btn
              @click="$routerBack()"
              outlined
              depressed
              tile
              class="cancelBtn mr-2 mb-2"
              >{{ $t("cancel") }}</v-btn
            >
          </div>

          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      projects: [],
    };
  },

  mounted() {
    this.fetchAllProjects();
  },

  methods: {
    fetchAllProjects() {
      var _this = this;
      this.$axios
        .get("/api/project/get-all-project")
        .then(function (response) {
          _this.projects = response.data;
        })
        .catch(this.onError);
    },
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>
